"use strict";
exports.__esModule = true;
exports.FEE_DISCLAIMER = void 0;
exports.FEE_DISCLAIMER = {
    DEFAULT: '*Includes a {{fee}}% bill payment fee',
    CREDIT: '*Includes a {{fee}}% fee for bill payment and card processing',
    SLC: '*Includes bill payment fee ({{fee}}% of rent)'
};
